import clsx from 'clsx'
import type { PropsWithChildren } from 'react'
import styles from './CardContainer.module.css'

type CardContainerProps = {
  id?: string
  className?: string
}

export const CardContainer = ({
  children,
  className,
  id,
}: PropsWithChildren<CardContainerProps>) => (
  <div id={id} className={clsx(styles.container, className)}>
    {children}
  </div>
)
